import React, { useState } from 'react';
import styles from './ActiveRegionsStats.module.css';

const FILTERS = [
    { key: 'week',  label: 'آخر أسبوع' },
    { key: 'month', label: 'آخر شهر' },
    { key: 'all',   label: 'الإجمالي' },
];

export default function ActiveRegionsStats({ data }) {
    const [filter, setFilter] = useState('all');

    const {
        total_governorates = 0,
        active_this_week   = 0,
        active_this_month  = 0,
        by_governorate     = [],
    } = data ?? {};

    const countKey = filter === 'week' ? 'week_protests' : filter === 'month' ? 'month_protests' : 'total_protests';
    const activeCount = filter === 'week' ? active_this_week : filter === 'month' ? active_this_month : total_governorates;
    const overallPct  = total_governorates > 0 ? Math.round((activeCount ?? 0) / total_governorates * 100) : 0;

    const sorted = [...by_governorate].sort((a, b) => b[countKey] - a[countKey]);
    const maxCount = Math.max(...sorted.map((g) => g[countKey]), 1);

    const cardLabel = filter === 'week'  ? 'النشاط هذا الأسبوع'
                    : filter === 'month' ? 'النشاط هذا الشهر'
                    : 'إجمالي النشاط';

    return (
        <div className={styles.wrapper}>

            <div className={styles.overview}>
                <div className={styles.coverageCard}>
                    <h3>{cardLabel}</h3>
                    <div className={styles.progressBar}>
                        <div className={styles.progress} style={{ width: `${overallPct}%` }} />
                    </div>
                    <p className={styles.bigPct}>{filter === 'all' ? '100' : overallPct}%</p>
                    <small>
                        {filter === 'all'
                            ? `${total_governorates} محافظة — كامل البيانات`
                            : `${activeCount} من ${total_governorates} محافظة نشطة`}
                    </small>
                </div>

                <div className={styles.filterGroup}>
                    {FILTERS.map((f) => (
                        <button
                            key={f.key}
                            className={`${styles.filterBtn} ${filter === f.key ? styles.filterActive : ''}`}
                            onClick={() => setFilter(f.key)}
                        >
                            {f.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className={styles.governorates}>
                {sorted.map((gov, idx) => {
                    const count    = gov[countKey];
                    const barWidth = Math.round(count / maxCount * 100);
                    const isActive = count > 0;
                    return (
                        <div key={idx} className={`${styles.govItem} ${!isActive ? styles.govInactive : ''}`}>
                            <div className={styles.govInfo}>
                                <span className={styles.govName}>{gov.name}</span>
                                <small>
                                    {filter !== 'all' && `${count} / `}{gov.total_protests} إجمالي
                                </small>
                            </div>
                            <div className={styles.progressBar}>
                                <div className={styles.progress} style={{ width: `${barWidth}%` }} />
                            </div>
                            <span className={`${styles.govPct} ${isActive ? styles.govPctActive : ''}`}>
                                {count}
                            </span>
                        </div>
                    );
                })}
            </div>

        </div>
    );
}
